import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class TabMonitorServiceTsService {

	private subject = new Subject<void>();
	tabSwitch$ = this.subject.asObservable();

	private listener = () => {
		if (document.hidden) {
			this.subject.next();
		}
	};

	start(): void {
		document.addEventListener('visibilitychange', this.listener);
	}

	stop(): void {
		document.removeEventListener('visibilitychange', this.listener);
	}

}
